const GUESS_LIMIT = 5;
const IMAGE_LIMIT = 1024 * 20 * 1024;
const FILE_LIMIT = 1024 * 300 * 1024;

export {
  GUESS_LIMIT,
  IMAGE_LIMIT,
  FILE_LIMIT
}